import { getAPIPath, requestGooseAPI } from '../shared/request'
import { APILocationUserProfileMembershipClientDtoResponse, LocationUserProfileMembershipClientDto } from '../types/api'
import {
  CLIENT_LOCATION_USER_PROFILE_MEMBERSHIP_ID_PATH,
  CLIENT_LOCATION_USER_PROFILE_MEMBERSHIP_PATH,
} from '../types/constants'

export const ClientLocationUserProfileMembershipService = {
  list: (locationName: string, includes?: string[]) =>
    requestGooseAPI<APILocationUserProfileMembershipClientDtoResponse>({
      url: getAPIPath(CLIENT_LOCATION_USER_PROFILE_MEMBERSHIP_PATH, { locationId: locationName }),
      method: 'GET',
      params: {
        includes,
      },
    }),
  get: (locationName: string, locationUserProfileMembershipId: string, includes?: string[]) =>
    requestGooseAPI<LocationUserProfileMembershipClientDto>({
      url: getAPIPath(CLIENT_LOCATION_USER_PROFILE_MEMBERSHIP_ID_PATH, {
        locationId: locationName,
        id: locationUserProfileMembershipId,
      }),
      method: 'GET',
      params: {
        includes,
      },
    }),
}
